import React, { useState, useEffect } from 'react'

import './popup.scss'

const Popup = ({ props }) => {
  const {
    isOpen,
    onSubmit,
    onClose = refresh => console.log('onClose(): ', { refresh }),
    branches = ['Redhill', 'Kingston'],
    initData = null,
    isTheme = false,
    items = [],
    onUpdateSubmit = () => console.log('> onUpdateSubmit!')
  } = props

  if (!isOpen) return null

  const [details, setDetails] = useState({
    name: '',
    type: '',
    subType: '',
    note: '',
    amount: {}
  })
  const [errors, setErrors] = useState([]) //err msg strings
  const [isLoading, setIsLoading] = useState(false)
  const [checked, setChecked] = useState(false)
  const [inputFields] = useState(Object.keys(details))
  const [includedItems, setIncludedItems] = useState([])
  const [oldData] = useState(initData)

  useEffect(() => {
    console.log({ oldData })
    const amount = {}
    branches.forEach(b => {
      amount[b.toLowerCase()] = {
        calcValue: 0,
        inputValue: 0
      }
    })

    if (initData) {
      if (isTheme) {
        setIncludedItems(initData.included)
        delete initData.included
      }
      initData.amount = { ...amount, ...initData.amount }
      setDetails(initData)
    } else {
      changeDetails({ amount })
    }
  }, [])

  useEffect(() => {
    console.log({ details })
  }, [details])

  const capitalise = str => {
    return str[0].toUpperCase() + str.substring(1)
  }

  const toLabel = str => capitalise(str) + ':'

  const changeDetails = change => {
    setDetails({ ...details, ...change })
  }

  const handleChange = e => {
    const { name, value } = e.target
    changeDetails({ [name]: value === '' ? '' : capitalise(value) })
  }

  const handleAmountChange = e => {
    const { name, value } = e.target
    //const _value = value === '' ? 0 : Number.parseInt(value)
    const obj = { calcValue: value, inputValue: value }
    const amount = { ...details.amount, ...{ [name.toLowerCase()]: obj } }
    changeDetails({ amount })
  }

  const handleCheckedChange = e => {
    setChecked(e.target.checked)
  }

  const handleIncludedChange = (e, index, field) => {
    const { value } = e.target
    const arr = [...includedItems]
    if (field === 'itemId') {
      arr[index][field] = value
    } else {
      arr[index][field] = !value ? 0 : parseInt(value)
    }
    setIncludedItems(arr)
  }

  const createInventoryUpdate = (_newData = null) => {
    if (!oldData) return false

    const newData = _newData || details
    const amount = {}

    branches.forEach(b => {
      b = b.toLowerCase()
      const { calcValue: oldCalc, inputValue: oldInput } = oldData.amount[b]
      const { calcValue: newCalc, inputValue: newInput } = newData.amount[b]

      if (oldCalc != newCalc) {
        amount[b] = { calcValue: [oldCalc, newCalc] }
      }

      if (oldInput != newInput) {
        const change = { inputValue: [oldInput, newInput] }
        amount[b] = amount[b] ? { ...amount[b], ...change } : change
      }
    })

    if (Object.keys(amount).length === 0) return false

    return {
      itemId: oldData.id,
      itemName: oldData.name,
      date: new Date(),
      amount
    }
  }

  const validateInput = () => {
    const getValue = num => {
      if (Number.isInteger(num)) return num
      num = num.trim()
      if (num === '') return 0
      return parseInt(num)
    }
    const { name, type, subType, note, amount } = details
    const msgs = []

    Object.keys(amount).forEach(b => {
      amount[b].inputValue = getValue(amount[b].inputValue)
      amount[b].calcValue = getValue(amount[b].calcValue)
    })

    console.log('validating...', { amount })

    const fixedDetails = {
      name: name.trim(),
      type: type.trim(),
      subType: subType.trim(),
      note: note.trim(),
      amount
    }

    if (name.trim() === '') msgs.push('Name cannot be empty')
    if (type.trim() === '') msgs.push('Type cannot be empty')

    return { msgs, fixedDetails }
  }

  const handleSubmit = () => {
    //Validation
    try {
      setIsLoading(true)
      const { msgs, fixedDetails } = validateInput()

      if (msgs.length > 0) {
        setErrors(msgs)
      } else {
        if (initData && !checked) {
          //i.e. do not overwrite calcValues
          const locations = Object.keys(details.amount)
          for (let i = 0; i < locations.length; ++i) {
            const loc = locations[i]
            if (!initData.amount[loc]) continue
            details.amount[loc].calcValue = initData.amount[loc].calcValue
          }
        }

        const toSend = isTheme
          ? { ...details, ...fixedDetails, included: includedItems }
          : { ...details, ...fixedDetails }

        onSubmit(toSend)
          .then(res => {
            console.log({ res })
            setErrors([])

            const update = createInventoryUpdate(toSend)
            if (update) {
              onUpdateSubmit(update)
                .then(res2 => console.log({ res2 }))
                .catch(err2 => console.log('onUpdateSumbitError: ', { err2 }))
            }
            onClose(true)
          })
          .catch(err => {
            console.log('Error in popup onSubmit: ', { err })
          })
      }
    } catch (err) {
      console.log('Error in Popup handleSubmit(): ', err)
    } finally {
      setIsLoading(false)
    }
  }

  // For Themes' Inclueded Items
  const addNewItem = () => {
    const _included = [...includedItems]
    _included.push({
      id: '',
      perTheme: 0,
      perChild: 0
    })
    setIncludedItems(_included)
  }

  const removeItem = index => {
    const _included = [...includedItems]
    _included.splice(index, 1)
    setIncludedItems(_included)
  }

  const createErrors = () => {
    const _errors = []

    errors.forEach((err, i) => {
      if (i === errors.length - 1) {
        return _errors.push(
          <div key={'popupError:' + i} className="popup-error-msg extraPadding">
            {err}
          </div>
        )
      }
      _errors.push(
        <div key={'popupError:' + i} className="popup-error-msg">
          {err}
        </div>
      )
    })

    return _errors
  }

  const createIncludedComps = () => {
    const comps = []
    includedItems.forEach((i, _index) => {
      const { itemId, perChild, perTheme } = i
      comps.push(
        <div key={'includedComp:' + _index} className="popup-included-item">
          <label>
            Select an item to include:
            <select
              value={itemId}
              onChange={e => handleIncludedChange(e, _index, 'itemId')}>
              <option value="" disabled>
                Select an item
              </option>
              {items.map((item, index) => (
                <option key={index} value={item.id}>
                  {item.name}
                </option>
              ))}
            </select>
          </label>

          {itemId && (
            <div>
              <label>
                How many per theme:
                <input
                  type="number"
                  value={perTheme}
                  onChange={e => handleIncludedChange(e, _index, 'perTheme')}
                  min="0"
                />
              </label>
              <label>
                How many per child:
                <input
                  type="number"
                  value={perChild}
                  onChange={e => handleIncludedChange(e, _index, 'perChild')}
                  min="0"
                />
              </label>
            </div>
          )}
          <button
            className="submit-button purple"
            onClick={() => removeItem(_index)}>
            {'Remove Item'}
          </button>
        </div>
      )
    })

    return comps
  }

  const createInputs = () => {
    const showValue = value => {
      if (!value) return ''
      if (Number.isInteger(value)) return value
      value = value.trim()
      if (value === '') return ''
      return parseInt(value)
    }

    const inputs = []
    const _names = inputFields
    _names.forEach((name, i) => {
      if (name === 'amount') {
        branches.forEach((b, j) => {
          inputs.push(
            <label key={'popupInput:' + (i + j)}>
              {'Amount - ' + b + ' Branch:'}
              <input
                className="popup-input"
                type="number"
                name={b}
                onChange={handleAmountChange}
                value={
                  details.amount[b.toLowerCase()]
                    ? showValue(details.amount[b.toLowerCase()].inputValue)
                    : ''
                }
              />
            </label>
          )
        })
      } else {
        inputs.push(
          <label key={'popupInput:' + i}>
            {toLabel(name)}
            <input
              className="popup-input"
              type="text"
              name={name}
              onChange={handleChange}
              value={details[name]}
            />
          </label>
        )
      }
    })
    return inputs
  }

  const createChecked = () => {
    if (initData) {
      return (
        <label key={'popupInput:checked'}>
          Check this box if you want to also update the calculated value
          <input
            className="popup-input"
            type="checkbox"
            onChange={handleCheckedChange}
            checked={checked}
          />
        </label>
      )
    }
    return <></>
  }

  return (
    <div className="popup-overlay">
      <div className="popup-container">
        <div className="popup-header">
          <h2>Add Inventory Item</h2>
          <div className="close-button" onClick={() => onClose(false)}>
            ×
          </div>
        </div>
        <div className="popup-content">
          {createErrors()}
          {createInputs()}
          {createChecked()}
          {isTheme && (
            <div className="popup-item-selection">
              <div className="popup-header2">
                <h3>Add Included Items</h3>
              </div>
              {createIncludedComps()}
              <button
                className="submit-button purple"
                onClick={() => addNewItem()}>
                {'Add Item'}
              </button>
            </div>
          )}
          <button className="submit-button" onClick={handleSubmit}>
            {'Save Changes'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default Popup
